import React from 'react'
import SvgWrapper from '../SvgWrapper'
import type { IllustrationProps } from './types'

const BaristaIllustration: React.FC<IllustrationProps> = ({ width = 124, height = 164 }) => (
  <SvgWrapper height={height} width={width} viewBox="0 0 123.75 164" fill="none">
    <g clipPath="url(#a)">
      <path
        d="M53.04 54.664 50.69 40.006l15.854-6.453 2.349 22.285-15.854-1.174ZM40.036 81.466s-.198 39.287-14.867 32.682C17.54 110.714 6.28 96.23 6.28 96.23l4.655-4.45 12.7 10.603 2.39-21.091 14.012.168v.006Z"
        fill="#604134"
      />
      <path
        d="M46.21 59.623s-9.721-2.748-14.97 4.8c-5.248 7.549-7.927 35.631-7.927 35.631l13.873 6.928 9.023-47.36Z"
        fill="#A5A9DA"
      />
      <path
        d="m98.934 80.51 6.166 23.292 14.956 44.275-7.788 4.414-19.577-44.057-4.948-23.507 11.19-4.417Z"
        fill="#604134"
      />
      <path
        d="m69.214 47.316-17.697.317-1.46 5.292-14.193 8.199 1.477 51.021 43.929 3.959 6.328-34.724 1.599-19.712-18.496-7.918-1.487-6.434Z"
        fill="#A5A9DA"
      />
      <path
        d="M78.247 65.063s7.974-7.832 14.031-2.375c6.058 5.457 13.321 41.606 13.321 41.606l-12.819 6.298-14.533-45.529Z"
        fill="#A5A9DA"
      />
      <path
        d="M78.957 69.916s-7.266-.33-13.211 1.32c-5.946 1.65-22.79-1.98-22.79-1.98 4.059 13.807 1.36 28.241-5.45 43.055-8.991 11.022 1.106 31.936-14.368 43.054h64.46l-2.365-28.373-3.633-10.558s1.982-1.979 1.321-2.639c-.66-.66-8.918-32.662-3.964-43.879Z"
        fill="#2E35A8"
      />
      <path
        d="m47.58 52.43-3.964 20.125 5.615 1.65-1.32-7.258 1.98-15.506-2.311.99ZM71.03 52.1l2.243 26.889 3.043-.165-1.982-25.404-3.303-1.32Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path
        d="M83.291 116.434s-17.71 4.784-32.574 3.135l-13.756-8.987-.611 1.563s11.93 14.939 20.828 14.068c8.898-.871 27.064-6.15 27.064-7.469 0-1.32-.951-2.31-.951-2.31Z"
        fill="#A5A9DA"
      />
      <path
        d="M9.885 95.915c1.969-1.505 1.672-5.195-.663-8.242-2.335-3.047-5.824-4.297-7.792-2.792-1.969 1.505-1.672 5.195.663 8.242 2.335 3.047 5.824 4.297 7.792 2.792ZM121.54 160.362c2.598-1.272 3.102-5.565 1.128-9.588-1.975-4.023-5.682-6.252-8.28-4.98-2.597 1.272-3.102 5.565-1.127 9.588 1.974 4.022 5.681 6.252 8.279 4.98Z"
        fill="#604134"
      />
      <path
        d="M82.026 119.78c1.956 2.458 1.972 6.097 4.568 8.116 1.077.838 2.626 1.283 3.95.795 1.312-.482 2.055-1.696 2.204-3.045.158-1.435-.44-2.801-1.299-3.923-.928-1.211-2.12-2.356-3.411-3.174-1.196-.759-2.653-1.154-4.033-.696-1.394.462-2.22 1.587-2.253 3.052-.026 1.023.119 2.062.195 3.078l.228 3.101.469 6.364c.046.63 1.037.637.99 0l-.733-9.953c-.059-.789-.148-1.581-.158-2.369-.01-.64.099-1.267.562-1.735.812-.822 2.1-.895 3.137-.535 1.288.445 2.352 1.458 3.293 2.408.915.928 1.814 2.043 2.012 3.369.158 1.056-.145 2.326-1.107 2.923-1.053.653-2.457.303-3.392-.399-1.225-.921-1.87-2.445-2.401-3.831-.572-1.491-1.113-2.985-2.117-4.246-.397-.498-1.094.205-.7.7h-.004Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path
        d="M81.792 118.747c-.885 1.115-1.417 2.409-1.919 3.728-.486 1.277-.978 2.626-1.89 3.672-.792.911-1.988 1.58-3.233 1.392-1.199-.181-1.919-1.243-2.001-2.398-.093-1.28.508-2.448 1.31-3.411.87-1.043 1.926-2.069 3.099-2.765 1.02-.607 2.26-.904 3.382-.38.486.228.902.604 1.097 1.116.264.699.132 1.511.079 2.236l-.822 11.178c-.047.637.944.633.99 0 .278-3.754.552-7.506.83-11.26.059-.825.155-1.696-.146-2.488a2.983 2.983 0 0 0-1.199-1.451c-1.156-.746-2.626-.736-3.864-.225-1.417.584-2.61 1.686-3.65 2.785-1.017 1.079-1.9 2.359-2.074 3.863-.149 1.287.257 2.709 1.308 3.53 1.142.894 2.685.825 3.95.241 3.415-1.577 3.35-6.018 5.457-8.663.393-.495-.304-1.198-.7-.7h-.004Z"
        fill="#020537"
        fillOpacity=".87"
      />
      <path
        d="M22.643 75.337s-7.488 7.086-20.099 0l1.972 23.618s.179.056.496.145c.228.829.855 1.511 1.707 1.779 2.745.867 8.023 2.049 11.59-.195a2.567 2.567 0 0 0 1.183-2.177v-.07a6.55 6.55 0 0 0 .79-.666l2.364-22.438-.003.004Z"
        fill="#FF0080"
      />
      <path
        d="M12.592 78.88c5.549 0 10.048-1.587 10.048-3.543 0-1.957-4.499-3.544-10.048-3.544-5.55 0-10.048 1.587-10.048 3.543 0 1.957 4.499 3.544 10.048 3.544Z"
        fill="#FFE0EA"
      />
      <path
        d="M119.089 137.361s-7.488 7.086-20.099 0l1.972 23.619s.178.056.496.145a2.57 2.57 0 0 0 1.707 1.778c2.745.868 8.023 2.049 11.59-.195a2.567 2.567 0 0 0 1.183-2.177v-.069c.277-.202.541-.419.789-.667l2.365-22.437-.003.003Z"
        fill="#FF0080"
      />
      <path
        d="M109.038 140.904c5.549 0 10.047-1.586 10.047-3.543s-4.498-3.543-10.047-3.543-10.048 1.586-10.048 3.543 4.499 3.543 10.048 3.543Z"
        fill="#FFE0EA"
      />
      <path
        d="M57.046 44.717c8.927 0 16.164-7.229 16.164-16.146 0-8.917-7.237-16.146-16.164-16.146-8.928 0-16.165 7.229-16.165 16.146 0 8.917 7.237 16.146 16.165 16.146Z"
        fill="#604134"
      />
      <path
        d="M52.23 8.245c3.237-.736 5.632-4.167 8.31-3.804 5.817.785 10.84 5.575 11.452 6.265 2.543 2.873 3.306 5.806 4.181 9.188.929 3.58-.026 8.891-.94 12.573-1.339 5.388-5.058 6.46-4.602 10.023.32 2.494 2.335 3.484 4.601 5.846 4.287 4.474 5.476 9.7 6.692 15.038 2.893 12.715-1.272 25.535-2.927 25.48-.35-.014-.65-.845-1.255-2.508-1.846-5.094-.938-6.651-2.09-8.354-2.058-3.045-6.461-.273-11.29-3.342-3.805-2.418-5.1-6.697-5.853-9.188-.432-1.432-2.262-7.476.42-13.365 2.484-5.453 6.097-5.697 8.736-12.118.555-1.352 2.391-4.863.462-7.512-.977-1.343-.782 6.272-2.242 5.025-3.554-3.029-1.975-15.397-5.285-18.809-1.582-1.633-3.98-2.27-5.853-2.088-4.452.429-12.363 4.757-13.06 9.524-1.12 7.671 1.424 11.02 7.624 16.79.67.623-1.863.29-2.927 0-5.41-1.471-7.524-8.462-7.943-10.023-1.236-4.58-.304-8.357.419-11.277.922-3.734 1.912-7.753 5.437-10.441 2.084-1.59 4.218-2.076 7.943-2.923h-.01Z"
        fill="#020537"
        fillOpacity=".87"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.127)" d="M0 0h123.746v164H0z" />
      </clipPath>
    </defs>
  </SvgWrapper>
)

export default BaristaIllustration
